import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const DotsVertical: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        d='M14.5 1V6H9.5V1H14.5Z'
        stroke={fill}
        strokeWidth='2'
      />
      <path
        d='M14.5 9.5V14.5H9.5V9.5H14.5Z'
        stroke={fill}
        strokeWidth='2'
      />
      <path
        d='M14.5 18V23H9.5V18H14.5Z'
        stroke={fill}
        strokeWidth='2'
      />
    </svg>
  )
}

export default DotsVertical
